import { render, staticRenderFns } from "./DlgCompanyUpdate.vue?vue&type=template&id=4f3d2c52&scoped=true"
import script from "./DlgCompanyUpdate.vue?vue&type=script&lang=js"
export * from "./DlgCompanyUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d2c52",
  null
  
)

export default component.exports